import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../../themes/Colors";

const TimeSheetCard = ({ timeCards, userInfo, staffArray, index }) => {
  const [displayCards, setDisplayCards] = useState(false);
  const [hover, setHover] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={() => {
          setSelectedIndex(displayCards ? null : index);
          setDisplayCards(displayCards ? false : true);
        }}
        style={{
          minHeight: 50,
          maxHeight: 50,
          width: "100%",
          cursor: "pointer",

          //   marginTop: 5,
          backgroundColor: displayCards
            ? BlackAndWhite.red
            : hover
            ? "#00000030"
            : "#FFFFFF",
          display: "flex",
          alignItems: "center",
          borderBottomStyle: "solid",
          borderBottomColor: "#00000030",
          borderBottomWidth: 1,
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: 16,
            marginLeft: 10,
            color: displayCards ? BlackAndWhite.secondary : null,
          }}
        >
          {" "}
          user info name
        </div>
        <div style={{ flex: 1 }} />{" "}
        <div
          style={{
            marginRight: 10,
            color: displayCards ? BlackAndWhite.secondary : null,
          }}
        >
          {" "}
          {displayCards ? "CLICK HERE TO CLOSE" : "CLICK TO OPEN DETAILS"}
        </div>
      </div>
      {displayCards ? (
        <>
          <div
            style={{
              width: "100%",
              minHeight: 40,
              backgroundColor: BlackAndWhite.primary,
              display: "flex",
              alignItems: "center",
              color: BlackAndWhite.secondary,
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            <div style={{ flex: 0.25 }}>
              <div style={{ marginLeft: 10 }}>DATE</div>
            </div>
            <div style={{ flex: 0.25 }}>CLOCKED IN</div>
            <div style={{ flex: 0.25 }}>CLOCKED OUT</div>
            <div
              style={{
                flex: 0.25,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              STATUS
            </div>
          </div>
          <div
            style={{
              minHeight: 400,
              maxHeight: 400,
              width: "100%",
              // borderStyle: "solid",
              display: "flex",
              flexDirection: "column",
              height: 400,
              backgroundColor: BlackAndWhite.secondary,
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                width: "100%",
                minHeight: 45,
                borderBottomStyle: "solid",
                borderBottomColor: "#00000030",
                borderBottomWidth: 1,
                display: "flex",
                alignItems: "center",
                fontSize: 14,
              }}
            >
              <div style={{ flex: 0.25 }}>
                <div style={{ marginLeft: 10 }}>DATE</div>
              </div>
              <div style={{ flex: 0.25 }}>CLOCKED IN</div>
              <div style={{ flex: 0.25 }}>CLOCKED OUT</div>
              <div
                style={{
                  flex: 0.25,
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                STATUS{" "}
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default TimeSheetCard;
